import React from 'react';
import { AppsMetaView } from './AppsMetaView';
import { useAppsMeta } from './hooks/useAppsMeta';
export const AppsMetaContainer = () => {
    const appsMeta = useAppsMeta();
    return (React.createElement(AppsMetaView, { statusTagProps: appsMeta.statusTagProps, connectBarProps: appsMeta.connectBarProps, configure: appsMeta.configure, settings: appsMeta.settings, customerSupport: appsMeta.customerSupport, products: appsMeta.products }));
};
